module.exports = __webpack_public_path__ + "static/media/p6.d082d439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p6.png
// module id = 960
// module chunks = 0